import { Text, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import useHelpers from 'hooks/helpers';
import styles from './Quote.module.scss';

type QuoteProps = ComponentProps & {
  fields: {
    quoteTitle: {
      value: string;
    };
    quoteAuthor: {
      value: string;
    };
  };
};

const Quote = ({ fields, rendering }: QuoteProps): JSX.Element => {
  const { anchorId, backgroundClass } = useHelpers(rendering);
  const color = backgroundClass.replace('background', '');
  return (
    <div id={anchorId} data-e2e-component-uid={rendering.uid} className="pb-4">
      <div className={`${backgroundClass} ${styles['quoteblock-root']} p-4`}>
        <Text tag="p" className="h3 background-to-change" field={fields.quoteTitle} />
        <Text
          tag="p"
          className={`background-to-change ${styles['section-header-large']} mt-2`}
          field={fields.quoteAuthor}
        />
        <div
          className={styles['arrow-right']}
          style={{ borderLeft: `41px solid var(-${color})` }}
        />
      </div>
    </div>
  );
};

export default withDatasourceCheck()<QuoteProps>(Quote);
